module.exports = __webpack_public_path__ + "img/g.3771f8f7.jpeg";